import React, { useCallback } from 'react';
import { Alert } from 'react-bootstrap';
import { useReportState } from '../../state/state';

export const Reporting = () => {
    const {reportSuccess, error, message} = useReportState()

    const clear = useCallback(() => {
        reportSuccess('');
    }, [reportSuccess]);

    return (
        <>
            {message && error ? <Alert variant='danger' dismissible onClose={clear}>{message}</Alert> : null}
            {message && !error ? <Alert variant='success' dismissible onClose={clear}>{message}</Alert> : null}
        </>
    );
}
